import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaHome, FaFilm, FaTv, FaSearch } from 'react-icons/fa';
import TVRemoteButton from '../TVRemoteButton.component';

const tabs = [
  { to: '/', icon: FaHome, label: 'Home' },
  { to: '/movies', icon: FaFilm, label: 'Movies' },
  { to: '/series', icon: FaTv, label: 'TV Series' },
  { to: '/search', icon: FaSearch, label: 'Search' },
];

const MobileBottomNav = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/watch')) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-dark-900/95 backdrop-blur-md border-t border-white/10 md:hidden safe-area-pb">
      <div className="flex items-center justify-around h-14">
        {tabs.slice(0, 3).map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-lg transition-colors ${
                isActive
                  ? 'text-accent-gold'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-semibold leading-none">{label}</span>
          </NavLink>
        ))}
        <TVRemoteButton variant="mobile" />
        {tabs.slice(3).map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-lg transition-colors ${
                isActive
                  ? 'text-accent-gold'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-semibold leading-none">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;